// extracted by mini-css-extract-plugin
export default {"title":"ForthScreen_title__35pUX","shimmer":"ForthScreen_shimmer__QLZUW","header":"ForthScreen_header__nJZNC","description":"ForthScreen_description__RUpwg"};